import * as DOMPurify from 'dompurify';
/**
 * Sanitizes the input string with default configuration
 * @param {string} dirty
 * @param {DOMPurify.Config} configuration (optional)
 * @returns {string} sanitized version of input
 */
export const htmlSanitizer = (dirty, configuration) => DOMPurify.sanitize(dirty, configuration || {});
